export class UserViewModel {
    public userId: number;
    public ad: string;
    public email: string;
    public roles: string[];
    public isGeneric: string;
    public token: string;
    public externalId: string;
    public tokenExpirationDate: Date;
    public isAuthenicated: Boolean;
    public entity: string[];
  }
